import React from 'react'
import { Breadcrumb } from 'antd'
import PropTypes from 'prop-types'
import CarDetailBody from './CarDetailBody'

/**
 * The routed car detail page. A thin shell around CarDetailBody, which the
 * list's quick-view modal renders too — so the page and the modal always show
 * the same thing.
 */
const Detail = props => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-md-12">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            <span>Home</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/cars">Cars</Breadcrumb.Item>
          <Breadcrumb.Item>Car Details</Breadcrumb.Item>
        </Breadcrumb>
        <br />
        <br />
        <CarDetailBody id={props.match.params.id} mode="page" />
      </div>
    </div>
  </div>
)

Detail.propTypes = {
  match: PropTypes.object
}

export default Detail
